export function getInitialPinnedCriteria() {
  return {
    exceptionLogs: [],
    invoices: [],
    levyCollectionProviders: [],
    notices: [],
    prismsUsers: [],
    providers: [],
    systemLogs: []
  };
}
